import i18next from 'i18next';

export const absenceCalendarStatus = {
    PENDING: 'E',
    APPROVED: 'A',
    REFUSED: 'R'
};

export function getAbsenceCalendarStatusDescription(key) {
    switch (key) {
        case absenceCalendarStatus.PENDING:
            return `${i18next.t('approvalCentral:status.pending')}`;
        case absenceCalendarStatus.APPROVED:
            return `${i18next.t('approvalCentral:status.approved')}`;
        case absenceCalendarStatus.REFUSED:
            return `${i18next.t('approvalCentral:status.refused')}`;
        default:
            return ``;
    }
}